module.exports = __webpack_public_path__ + "img/qsp.5e19d4d6.svg";